module.exports = __webpack_public_path__ + "static/media/problem_img2.4bdde931.png";